module.exports = __webpack_public_path__ + "static/media/ITCAvantGardeStd-Bk.d48571e4.svg";